import CosmosBackground from "./CosmosBackground"
import "../screens/OnboardingScreen.css"

export default function AuthCard({ children }) {
  return (
    <div className="onboardingScreen">
      <CosmosBackground />
      <div className="onboardingScreen__body">
        <div className="onboardingScreen__form">
          <img
            className="onboarding__logo"
            src={process.env.PUBLIC_URL + "/Primário_5.svg"}
            alt="Cosmo"
          />
          {children}
        </div>
      </div>
    </div>
  )
}
